<template>
  <div class="ma-6">
    <h3>Comandos para setup da câmera na plataforma Oderon, via SD Card:</h3>
    <p>(copie o texto abaixo para um arquivo <code>writeconfig.txt</code> na raiz do SDCard)</p>
    <pre class="mt-4">{{writeconfigTxt}}</pre>
    <h3 class="mt-8">Comandos para setup da câmera na plataforma Oderon, via SMS:</h3>
    <p>(envie os comandos abaixo para o número de celular associado ao SIMCard)</p>
    <pre class="mt-4">{{writeconfigSms}}</pre>
    <h3 class="mt-8">Comandos úteis:</h3>
    <pre>{{usefulCommands}}</pre>
    <h3 class="mt-8">URL do livestream:</h3>
    <h4 class="mt-4">Para câmeras modelo JC400 (antigo)</h4>
    <pre>http://jimi.oderon.com.br:8000/live/{{IMEI}}.flv</pre>
    <h4 class="mt-4">Para câmeras modelo JC400AD (novo) firmware 1.4</h4>
    <pre>http://jimi.oderon.com.br:8000/live0/{{IMEI}}.flv (externa frontal)</pre>
    <pre>http://jimi.oderon.com.br:8000/live1/{{IMEI}}.flv (interna fadiga)</pre>
    <h4 class="mt-4">Para câmeras modelo JC400AD (novo) firmware 1.6 (PENDENTE TESTE)</h4>
    <pre>http://jimi.oderon.com.br:8000/live1/{{IMEI}}.flv (externa frontal)</pre>
    <pre>http://jimi.oderon.com.br:8000/live2/{{IMEI}}.flv (interna fadiga)</pre>
  </div>
</template>

<script>
import EditStore from './EditStore'
const writeconfigTxt = `SERVER,1,jimi.oderon.com.br,9018
UPLOAD,http://jimi.oderon.com.br:9019/upload
RSERVICE,jimi.oderon.com.br:9023/live
FILELIST,http://jimi.oderon.com.br:9019/filelist
APN,kore.br,kore.br
NO,REMOVE`

const writeconfigSms = `SERVER#666666#1#jimi.oderon.com.br#9018
UPLOAD#666666#http://jimi.oderon.com.br:9019/upload
RSERVICE#666666#jimi.oderon.com.br:9023/live
FILELIST#666666#http://jimi.oderon.com.br:9019/filelist
APN#666666#kore.br#kore.br`

const usefulCommands = `
REBOOT                      Reinicia a câmera
VERSION                     Retorna a versão do firmware
APN                         Retorna qual APN está sendo usada
STATUS                      Retorna níveis de sinal GSM e GPS
PARAM                       Retorna o IMEI
DMS_VIRTUAL_SPEED,60        "Força" uma velocidade para testes (60kmh)
RTMP,ON,IN                  Inicia streaming (câmera IN)
RTMP,OFF,IN                 Termina streaming (câmera IN)
VOLUME,1                    Seta o volume. 0=off, 3=max, 2=default
DMS_SWITCH,A,B,C            Default 1,1,15
                              A: DMS Switch: 1=on, 0=off
                              B: Sensitivity: 1=normal, 2=agressiva
                              C: Velocidade mínima, em KM/H (setamos para 0)
DMS_CONTINUITY,A,B,C,D,E,F  Valor em segundos, default: 1,2,5,3,4,10
                              A: Olhos fechados
                              B: Bocejo
                              C: Distração (aumentamos para 8)
                              D: Cigarro
                              E: Celular
                              F: Perdeu rosto
DMS_SECOND_EVENT,A,B,C,D    Configura o "second level event":
                              A: Tipo do evento (1=Distração, 2=Olhos fechados,
                                3=Bocejo,4=Celular,5=Cigarro,6=Perdeu rosto)
                              B: Vezes para "trigger the second event" (0=off)
                              C: Duração do buzzer (0=off)
                              D: Tempo (1 a 180 segundos)
RECORDAUDIO,0               Desliga (0) ou liga (1) a gravação de áudio em eventos
RECORDAUDIO_SUB,0           Desliga (0) ou liga (1) a gravação de áudio em streaming e playback.

SSID,A,B,C                  Configura e adiciona uma rede wifi:
                              A: Funcionamento do wifi:
                                0 = off
                                1 = ligado quando tem ignição
                                2 = ligado direto
                                3 = apagar todas as redes
                              B: SSID (nome) da rede (cuidado com maiúsculas e minúsculas)
                              C: Senha da rede (cuidado com maiúsculas e minúsculas)

HTTPUPLOADLIMIT,A,B         Configura o comportamento quando não consegue fazer upload do vídeo:
                              A: Quantidade de tentativas (1-10, default 5)
                              B: Minutos entre cada tentativa (1-30, default 3)
                              (Envie o comando sem parâmetros para consultar os valores atuais)

EVIDEO,A,B,C                Pede para a câmera recortar e fazer upload de um arquivo de vídeo.
                              A: Data/hora do "centro" do vídeo (YY-MM-DD HH:mm:ss)
                              B: Canal: 1 para a câmera frontal externa, 2 para a câmera interna de fadiga
                              C: Tamanho em segundos do vídeo retornado (10-60, default 15s)
`.trim()

export default {
  tabTitle: 'Utilização',
  data() {
    return { writeconfigTxt, writeconfigSms, usefulCommands }
  },
  computed: {
    IMEI() {
      return EditStore.row.imei
    }
  }
}
</script>

<style></style>
